// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import { API_KEY } from '@app/core/environment.configuration';

@Injectable()
export class MembershipsService {
  constructor(private httpClient: HttpClient, @Inject(API_KEY) private api: string) {}

  public uploadCompanyLogo(accountId: string, logo: File): Observable<boolean> {
    return this.getPresignedCompanyLogoUrl(accountId, logo).pipe(
      switchMap((url: string) => this.uploadToPresignedUrl(url, logo))
    );
  }

  private getPresignedCompanyLogoUrl(accountId: string, logo: File): Observable<string> {
    const route = `${this.api}/membership-onboarding/logo/${accountId}`;
    return this.httpClient
      .put<PresignedPutResponse>(route, logo)
      .pipe(map((response: PresignedPutResponse) => response.url));
  }

  private uploadToPresignedUrl(url: string, file: File): Observable<boolean> {
    const headers = this.getPresignedPutHeaders();
    return this.httpClient.put(url, file, { headers }).pipe(map((response: any) => true));
  }

  private getPresignedPutHeaders() {
    return new HttpHeaders({
      'x-amz-acl': 'public-read'
    });
  }
}

interface PresignedPutResponse {
  url: string;
}



// WEBPACK FOOTER //
// ./src/app/core/services/memberships.service.ts